import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('RuleProfit')
export class RuleProfit {
  @JsonProperty('target', Number, true) target: number = undefined;
  @JsonProperty('lowest', Number, true) lowest: number = undefined;
  @JsonProperty('highest', Number, true) highest: number = undefined;
}
